import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useTicketStatus, TicketStatus } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<TicketStatus>
      useData={useTicketStatus}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
